/* eslint-disable no-unused-vars */

import Form from './Form'
import ViewImage from './ViewImage'

const App = () => {
  return (
    <div className="main center">
      <div className = "container ">
      <Form />
      <ViewImage />
    </div>
    </div>
    
   
  );
}

export default App;
